import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MpsUser } from '../../app/models/mps-user.model';
import { MpsPermissionHelper } from '../helpers/mps-permission.helper';
import { mpsRouteNames } from '../mps-route-names';
import { MpsUserService } from '../services/mps-user.service';

/**
 * Autorise la route si le rôle de l'utilisateur figure dans `data.roles`.
 * L'administrateur passe partout. Sinon, retour à la page d'accueil du rôle.
 */
export const MpsRoleGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const userService = inject(MpsUserService);
  const loggedInUser = userService.getUser();

  if (!loggedInUser) {
    return router.navigateByUrl(mpsRouteNames.auth + '/' + mpsRouteNames.login);
  }

  const user = new MpsUser(loggedInUser);
  return MpsPermissionHelper.canUserActivate(user, route)
    ? true
    : router.navigateByUrl(MpsPermissionHelper.defaultRouteFor(user));
};
